import { isAxiosError } from "axios";
import axiosInstance from "../../utils/axiosInstance";
import {
  createRequestPrice,
  updateRequestPrice,
  setServiceRequest,
  setServiceRequests,
  setLoadingTrue,
  setLoadingFalse,
  setPriceLoadingTrue,
  setPriceLoadingFalse,
} from "../../store/slices/request";
import { setMessage } from "../../store/slices/message";
import { AppDispatch } from "../../store/store";
import {
  ICreateRequestPrice,
  IRequestQueryParams,
  IPrice,
  IUpdateRequestPrice,
} from "../../store/@types/requests";

export const getServiceRequests = async (
  dispatch: AppDispatch,
  params: IRequestQueryParams,
) => {
  dispatch(setLoadingTrue());

  try {
    const response = await axiosInstance.get("v1/request-services", {
      params,
    });

    const data = response.data;
    dispatch(setServiceRequests(data));
  } catch (error) {
    if (isAxiosError(error)) {
      console.error(error.response?.data || error.message);
    } else {
      console.error(error);
    }
  } finally {
    dispatch(setLoadingFalse());
  }
};

export const getServiceRequest = async (dispatch: AppDispatch, id: string) => {
  dispatch(setLoadingTrue());
  try {
    const response = await axiosInstance.get(`v1/request-services/${id}`);

    const { data } = response.data;
    dispatch(setServiceRequest(data));
  } catch (error) {
    if (isAxiosError(error)) {
      console.error(error.response?.data || error.message);
    } else {
      console.error(error);
    }
  } finally {
    dispatch(setLoadingFalse());
  }
};

// service request price 
export const createServiceRequestPrice = async (
  dispatch: AppDispatch,
  formData: ICreateRequestPrice,
) => {
  dispatch(setPriceLoadingTrue());
  try {
    const response = await axiosInstance.post(
      "v1/create-request-price",
      formData,
    );
    const { message, data } = response.data;

    if (data) {
      dispatch(createRequestPrice(data as IPrice));
    }
    dispatch(setMessage({ type: "success", message }));
    return true;
  } catch (error) {
    if (isAxiosError(error)) {
      const message = error.response?.data?.message || error.message;
      dispatch(setMessage({ type: "error", message }));
    } else {
      dispatch(setMessage({ type: "error", message: "Unable to add price." }));
      console.error(error);
    }
    return false;
  } finally {
    dispatch(setPriceLoadingFalse());
  }
};

export const updateServiceRequestPrice = async (
  dispatch: AppDispatch,
  formData: IUpdateRequestPrice,
) => {
  dispatch(setPriceLoadingTrue());
  try {
    const response = await axiosInstance.patch(
      "v1/update-request-price",
      formData,
    );
    const { message, data } = response.data;

    if (data) {
      dispatch(updateRequestPrice(data as IPrice));
    }
    dispatch(setMessage({ type: "success", message }));
    return true;
  } catch (error) {
    if (isAxiosError(error)) {
      const message = error.response?.data?.message || error.message;
      dispatch(setMessage({ type: "error", message }));
    } else {
      dispatch(setMessage({ type: "error", message: "Unable to update price." }));
      console.error(error);
    }
    return false;
  } finally {
    dispatch(setPriceLoadingFalse());
  }
};